import React, {createRef, useState, useContext} from "react";
import {Fade, Slide} from "react-reveal";
import "./EducationCard.scss";
import StyleContext from "../../contexts/StyleContext";

export default function EducationCard({school}) {
  const imgRef = createRef();
  const [showCoursework, setShowCoursework] = useState(false);

  const GetDescBullets = ({descBullets}) => {
    return descBullets
      ? descBullets.map((item, i) => (
          <li key={i} className="subTitle">
            {item}
          </li>
        ))
      : null;
  };
  const {isDark} = useContext(StyleContext);

  if (!school.logo)
    console.error(`Image of ${school.name} is missing in education section`);
  return (
    <div>
      <Fade left duration={1000}>
        <div className="education-card">
          {school.logo && (
            <div className="education-card-left">
              <img
                crossOrigin={"anonymous"}
                ref={imgRef}
                className="education-roundedimg"
                src={school.logo}
                alt={school.schoolName}
              />
            </div>
          )}
          <div className="education-card-right">
            <h5 className="education-text-school">{school.schoolName}</h5>

            <div className="education-text-details">
              <h5
                className={
                  isDark
                    ? "dark-mode education-text-subHeader"
                    : "education-text-subHeader"
                }
              >
                {school.subHeader}
              </h5>
              <p
                className={`${
                  isDark ? "dark-mode" : ""
                } education-text-duration`}
              >
                {school.duration}
              </p>
              <p className="education-text-desc">{school.desc}</p>
              <div className="education-text-bullets">
                <ul>
                  <GetDescBullets descBullets={school.descBullets} />
                </ul>
              </div>
              {school.coursework && school.coursework.length > 0 && (
                <div className="education-coursework">
                  <button
                    className={`coursework-toggle ${isDark ? "dark-mode" : ""}`}
                    onClick={() => setShowCoursework(!showCoursework)}
                  >
                    {showCoursework ? "Hide Coursework ▲" : "View Coursework ▼"}
                  </button>
                  {showCoursework && (
                    <div className="coursework-content">
                      {school.coursework.map((group, i) => (
                        <div key={i} className="coursework-group">
                          <h6 className={`coursework-category ${isDark ? "dark-mode" : ""}`}>
                            {group.category}
                          </h6>
                          <div className="coursework-tags">
                            {group.courses.map((course, j) => (
                              <span key={j} className={`coursework-tag ${isDark ? "dark-mode" : ""}`}>
                                {course}
                              </span>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </Fade>
      <Slide left duration={2000}>
        <div className="education-card-border"></div>
      </Slide>
    </div>
  );
}
